module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0009.jpg?v=0fd08a8c";